import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import MforderInfo from './MforderInfo';
import MfproductorderInfo from 'components/mfproductorder/action/updateProductOrderStatus/MfproductorderInfo';
import UpdateStatusRadio from './UpdateStatusRadio';
import TaskinstanceInfo from './TaskinstanceInfo';
import {setSelectedMfproductorderId} from 'store/slice/ManufSlice';
import HandleStitchingTask from './HandleStitchingTask';
import { userprofileInfo } from 'store/slice/HeaderSlice';


export default function UpdateStatusActionImpl(){
    const dispatch = useDispatch();
    const {taskinstanceObj} = useSelector((state)=>state.manufslice.taskinstanceDashboard);
    const { mfproductorderList } = useSelector((state) => state.manufslice);
    const {userprofileInfo} = useSelector((state) => state.headerslice);
    
    useEffect(()=>{
        const matchedOrder = mfproductorderList.find(order => order.id === taskinstanceObj.productorderid);
        dispatch(setSelectedMfproductorderId(matchedOrder.id));
    
    },[])
    
    return (
        <>
        <Grid container >
            
            <Grid item lg={4} xs={12} sx={{padding:1}}><MforderInfo/></Grid>
            <Grid item lg={4} xs={12} sx={{padding:1}}><MfproductorderInfo/></Grid>
            
            <Grid item lg={4} xs={12} sx={{padding:1}}><TaskinstanceInfo/></Grid>
            <Grid item lg={4} xs={12} sx={{padding:1}}><UpdateStatusRadio/></Grid>
           
        </Grid>
        {/* <Grid container >
            {taskinstanceObj.taskid===5?<>
            <HandleStitchingTask/>
            
            </>:<>
            <Grid item lg={4} xs={12} sx={{padding:1}}><MforderInfo/></Grid>
            <Grid item lg={4} xs={12} sx={{padding:1}}><MfproductorderInfo/></Grid>
            
            <Grid item lg={4} xs={12} sx={{padding:1}}><TaskinstanceInfo/></Grid>
            <Grid item lg={4} xs={12} sx={{padding:1}}><UpdateStatusRadio/></Grid>
            </>}
        </Grid> */}
        
       
        </>
    )
}